import { LocationStatus, type LocationResponse } from "@models/location";

// A location may only be used for checkout once it has been Approved (E1-S7,
// per-location cert). Isolated here so a wire-format change (e.g. status arriving
// as a string) is a one-line edit. A missing status is treated as not-approved.
export const isLocationApproved = (location?: LocationResponse): boolean =>
    location?.status === LocationStatus.Approved;
